import { GAME_ID, REDUX_ACTIONS } from '../../data/constants';

const initState = {
  levelIndex: 0,
  itemIndex: 0,
  progress: 0,
  passageIdsInLevel: [],
  isResuming: false,
  records: [],
};

const roundPlayReducer = (state = initState, { type, payload, gameId }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.SET_LEVEL_INDEX:
      return {
        ...state,
        levelIndex: payload.levelIndex,
        itemIndex: payload.currentItemIndex,
        isResuming: payload.currentItemIndex !== 0,
        records: payload.records,
        progress: payload.progress,
      };

    case REDUX_ACTIONS.INITIALIZE_ROUND:
      return {
        ...state,
        passageIdsInLevel: payload.passageIdsInLevel,
        progress: state.progress,
      };

    case REDUX_ACTIONS.NEXT_STANDARD_ITEM:
      return {
        ...state,
        itemIndex: state.itemIndex + 1,
        isResuming: false,
      };

    case REDUX_ACTIONS.COMPLETE_QUESTION: {
      return {
        ...state,
        progress: state.progress + 1,
      };
    }

    case REDUX_ACTIONS.UPDATE_RECORDS:
      return {
        ...state,
        records: [...state.records, payload],
      };

    default:
      return state;
  }
};

export default roundPlayReducer;
